import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextCard from 'components/molecules/Cards/ContextCard/ContextCard';

const StyledDealflowStatusContextCard = styled(ContextCard)` 
  .DealflowStatusContextCard {
    &-chip {
      min-width: 100%;
    }
  }
  ${ComponentStyles}
`;

StyledDealflowStatusContextCard.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowStatusContextCard;
